import { TOKEN_KEY, USER_KEY } from '../constants';
export default (function () {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
});